var Controller = require("common/Controller");
var Utils = require("common/Utils");

function LaunchAttributesController(attributesDialog) {
    Controller.call(this);

    var self = this;

    function initialiseServerPath() {
        if (Utils.isGreaterThanOrEqualToServerVersion(CudaLaunch.serverConfiguration.version, "7.1.0")) {
            self.apiUrl = "/sslvpn_api/launchPrerequisites";
        } else {
            self.apiUrl = "/sslvpn_api/requiredLaunchAttributes";
        }
    }
    $(document).on("connectionsuccessful", initialiseServerPath);
    $(document).on("initialiseServerPaths", initialiseServerPath);

    /**
     * @override
     * @inheritsDoc
     */
    this.getId = function() {
        return "LaunchAttributesController";
    };

    this.getViews = function() {
        return [attributesDialog];
    };

    self.subscribeTo("post-and-validate-attributes", function(data) {
        self.postAndValidateAttributes(data.submitData, data.launchId, data.deferred, data.launchCallback, data.saveAttributes);
    });

    this.resolveAttributes = function(attributes, launchId, launchCallback, title, allowSave) {
        return attributesDialog.promptForAttributes(attributes, launchId, launchCallback, title, allowSave);
    };

    this.postAndValidateAttributes = function(submitData, launchId, deferred, launchCallback, saveAttributes) {
        // Confirm path has been initialised
        if (!self.apiUrl) {
            initialiseServerPath();
        }

        if (submitData) {
            for (var i = 0; i < submitData.length; i++) {
                var submittedAttr = submitData[i];

                if (submittedAttr.hasOwnProperty("namespace") && submittedAttr.namespace === "session") {
                    // As you can't enter a bad session password (i.e. no validation) we don't need to worry about partial successes
                    if (submittedAttr.hasOwnProperty("name") && submittedAttr.hasOwnProperty("value")) {
                        var key = submittedAttr["name"];
                        var val = submittedAttr["value"];

                        if (val !== "" && key !== "") {
                            var session = CudaLaunch.serverConfiguration.getSession();
                            session.completedAuthSchemes[key] = val;
                        }
                    }
                }
            }
        }

        return $.ajax({
            url : self.apiUrl,
            type : "POST",
            data : {
                changes : JSON.stringify(submitData),
                launchId : launchId
            }
        }).done(function(response) {
            launchCallback(response.launchToken, saveAttributes);
            attributesDialog.postDone(deferred, submitData);
        }).fail(function(xHR) {
            console.info("required attributes have errors");
            var errorsJson = xHR.responseJSON.validationErrors;
            attributesDialog.postFailed(errorsJson);
        });
    };
}

Utils.inherits(LaunchAttributesController, Controller);

module.exports = LaunchAttributesController;